// useUploadCustomLogo

import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const {
  CONTROLLERS: {
    CUSTOM_LOGO: { VERSION, BASE },
  },
} = USER;

export interface ILogoData {
  url: string;
  externalId: string;
}

const buildFormDate = (file: File) => {
  const fd = new FormData();
  if (file) fd.append('logo', file, 'logo');
  return fd;
};
export const useUploadCustomLogoMutation = ({
  customerId,
  logo,
  onSuccess,
  onError,
}: {
  customerId: string;
  logo: File | null;
  onSuccess?: (logoData: ILogoData) => void;
  onError?: () => void;
}) => useMutation(
  async () => {
    if (!customerId || !logo) return '';
    const { data } = await httpService.post(
      `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
      buildFormDate(logo),
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return data;
  },
  {
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: () => {
      if (onError) {
        onError();
      }
    },
  },
);
